import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Location } from '@interfaces';
import { DialogLocationsComponent } from '../../dialogs/dialog-location/dialog-locations.component';
import { LocationService } from '../../services/location.service';

@Component({
  selector: 'popup-marker',
  template: `
    <p class="m-0 s-14 font-weight-600">{{ location.name }}</p>
    {{ location.address.formattedAddress }}<br>
    <b class="link" (click)="openDialog(location)">Ver mais</b>
  `
})
export class PopupMarkerComponent {
  public location: Location;

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly locationService: LocationService,
    private readonly fuseProgressBarService: FuseProgressBarService,
    private readonly matDialog: MatDialog
  ) {}

  public reload = () => {};

  async openDialog(selectedLocation: Location): Promise<void> {
    this.fuseProgressBarService.show();
    const location = await this.locationService.getLocationById(selectedLocation.id);
    this.fuseProgressBarService.hide();
    const result = await this.matDialog.open(DialogLocationsComponent, {
      panelClass: ['dialog-locations'],
      data: {
        location,
        isViewMode: !this.authenticationService.hasPermission('locations-edit')
      }
    }).afterClosed()
      .toPromise();

    if (result && result.reload) {
      this.reload();
    }
  }
}
